/** Banconote e monete in circolazione (200 € → 0,10 €) */
export const EURO_DENOMINATIONS = [
  { id: '200', value: 200, label: '200 \u20AC', kind: 'note' },
  { id: '100', value: 100, label: '100 \u20AC', kind: 'note' },
  { id: '50', value: 50, label: '50 \u20AC', kind: 'note' },
  { id: '20', value: 20, label: '20 \u20AC', kind: 'note' },
  { id: '10', value: 10, label: '10 \u20AC', kind: 'note' },
  { id: '5', value: 5, label: '5 \u20AC', kind: 'note' },
  { id: '2', value: 2, label: '2 \u20AC', kind: 'coin' },
  { id: '1', value: 1, label: '1 \u20AC', kind: 'coin' },
  { id: '0.50', value: 0.5, label: '0,50 \u20AC', kind: 'coin' },
  { id: '0.20', value: 0.2, label: '0,20 \u20AC', kind: 'coin' },
  { id: '0.10', value: 0.1, label: '0,10 \u20AC', kind: 'coin' }
];
